module.exports = __webpack_public_path__ + "img/AddCardOutlined.a2c7935b.svg";